import { useState } from "react";
import { Box, Button, TextField, IconButton } from "@mui/material";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import GenericModal from "../GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import moment from "moment";
import { IBookingConfirmationModalProps } from "../../Utils/Types";
import styles from "./DrivingSessionScheduling.module.css";
import EmojiPicker, { EmojiClickData } from "emoji-picker-react";

export default function BookingConfirmationModal({
  open,
  date,
  event,
  onClose,
  onConfirm,
}: IBookingConfirmationModalProps) {
  const [comments, setComments] = useState<string>("");
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    setComments((prev) => prev + emojiData.emoji);
  };

  const handleConfirm = () => {
    onConfirm(comments);
    setShowEmojiPicker(false);
  };

  const handleClose = () => {
    setComments("");
    setShowEmojiPicker(false);
    onClose();
  };

  return (
    <GenericModal
      open={open}
      onClose={handleClose}
      title={Vocabulary.confirm}
      actions={
        <>
          <Button onClick={handleClose} variant="outlined">
            {Vocabulary.cancel}
          </Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            {Vocabulary.confirm}
          </Button>
        </>
      }
    >
      <Box className={styles.modalContent}>
        <Box className={styles.confirmationMessage}>
          {event
            ? `Confirmați rezervarea pentru ${moment(date).format(
                "DD MMM YYYY"
              )} de la ${moment(event.startDate).format("HH:mm")} până la ${moment(event.endDate).format("HH:mm")}?`
            : `Confirmați rezervarea pentru ${moment(date).format(
                "DD MMM YYYY [la] HH:mm"
              )}?`}
        </Box>

        <Box className={styles.commentsSection}>
          <Box className={styles.commentsHeader}>
            <IconButton
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              className={styles.emojiButton}
              size="small"
            >
              <EmojiEmotionsIcon />
            </IconButton>
          </Box>

          {showEmojiPicker && (
            <Box className={styles.emojiPickerContainer}>
              <EmojiPicker onEmojiClick={handleEmojiClick} width="100%" />
            </Box>
          )}

          <TextField
            label={Vocabulary.observations}
            multiline
            rows={4}
            fullWidth
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder="Adaugă comentarii (opțional)"
            className={styles.commentsField}
          />
        </Box>
      </Box>
    </GenericModal>
  );
}
